import { Box, Chip, Typography } from "@mui/material";
import { MembershipOption } from "../types";

interface MembershipOptionCardProps {
  option: MembershipOption;
  isSelected: boolean;
  onClick?: () => void;
}

const getBadge = (supportHours: number) => {
  if (supportHours == 8) {
    return {
      label: "Most popular",
      color: "green",
    };
  }
  if (supportHours == 20) {
    return {
      label: "Elite talent",
      color: "teal",
    };
  }
  return null;
};

export const MembershipOptionCard = ({
  option,
  isSelected,
  onClick,
}: MembershipOptionCardProps) => {
  const textSecondaryColor = isSelected ? "white" : "textSecondary";
  const hasBadge = option.supportHours == 8 || option.supportHours == 20;

  return (
    <Box
      onClick={onClick}
      sx={(theme) => ({
        border: isSelected
          ? `2px solid ${theme.palette.teal[4]}`
          : `1px solid ${theme.palette.border}`,
        borderRadius: "16px",
        padding: isSelected ? "15px 19px" : "16px 20px",
        display: "flex",
        flexDirection: "column",
        backgroundColor: isSelected ? theme.palette.teal[1] : "white",
        gap: "2px",
        cursor: "pointer",
      })}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: hasBadge ? "start" : "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography variant="h4">{option.name}</Typography>
          {option.descriptionOverride ? (
            <Typography
              variant="body"
              color={textSecondaryColor}
              sx={{ whiteSpace: "pre-line" }}
            >
              {option.descriptionOverride}
            </Typography>
          ) : (
            <>
              <Typography variant="bodyHeavy" color="primary.main">
                {option.descriptionOverride ||
                  `${option.supportHours} hours of support`}
              </Typography>
            </>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            justifyContent: hasBadge ? "start" : "center",
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Typography variant="h4">
              ${(option.amountCents / 100).toLocaleString("en-US")}
            </Typography>
            <Typography variant="body">
              /mo
              {option.promotionsDisabled && (
                <span color={textSecondaryColor}>*</span>
              )}
            </Typography>
          </Box>

          {hasBadge && (
            <Chip
              label={getBadge(option.supportHours)?.label}
              variant={
                (isSelected
                  ? "green"
                  : getBadge(option.supportHours)?.color) as any
              }
              size="small"
              sx={{
                border: "1px solid transparent",
                "& .MuiChip-label": { fontSize: "13px" },
              }}
            />
          )}
        </Box>
      </Box>
      <Typography variant="body" color="text.primary">
        {option.description}
      </Typography>
    </Box>
  );
};
